/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { SecureStorageService } from "./types";

export default CustomPlatform.select<() => SecureStorageService>({
  web: () => require("./secure-storage.web").default,
  default: () => require("./secure-storage").default,
})();
